module.exports = __webpack_public_path__ + "img/kefuweixin.8d8efc0d.png";